import { render, staticRenderFns } from "./basciMessage.vue?vue&type=template&id=2b9fb9dc&"
import script from "./basciMessage.vue?vue&type=script&lang=js&"
export * from "./basciMessage.vue?vue&type=script&lang=js&"
import style0 from "./basciMessage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports